import {Dispatch, FC, SetStateAction, useRef} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {CheckingModel} from '../../../../models/ckecking.model'
import {Button} from '../../../../../../components/UI/Button'
import {useReactToPrint} from 'react-to-print'
import React from 'react'
import './Chekin.css'
import {getSnackBar} from '../../../../../../util/snackBar'
import {
  downloadPDFCheckInOutService,
  sendEmailCheckInOutService,
} from '../../../../services/booking.service'
import moment from 'moment'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  checkIn: CheckingModel
  getChekings: () => void
}

type ComponentToPrintProps = {
  // Otras props específicas de tu componente
  checkIn: CheckingModel
}

const ComponentToPrint = React.forwardRef<HTMLDivElement, ComponentToPrintProps>(
  ({checkIn}, ref) => {
    return (
      <div ref={ref}>
        <div className='row'>
          <div className='col-6'>
            <div className='d-flex'>
              <h5 className='me-2'>Nro Reserva:</h5>
              <span>{checkIn.CodigoReserva}</span>
            </div>
            <div className='d-flex'>
              <h5 className='me-2'>Módulo:</h5>
              <span>{checkIn.Modulo}</span>
            </div>
            <div className='d-flex'>
              <h5 className='me-2'>Habitación:</h5>
              <span>{checkIn.Habitacion}</span>
            </div>
            <div className='d-flex'>
              <h5 className='me-2'>Cama:</h5>
              <span>{checkIn.CodigoCama}</span>
            </div>
            <div className='d-flex'>
              <h5 className='me-2'>Tipo de Cama:</h5>
              <span>{checkIn.CamaTipo}</span>
            </div>
          </div>
          <div className='col-6'>
            <div className='d-flex'>
              <h5 className='me-2'>Huesped:</h5>
              <span>{checkIn.HuespedDescripcion}</span>
            </div>
            <div className='d-flex'>
              <h5 className='me-2'>Tipo de Empresa:</h5>
              <span>{checkIn.TipoEmpresa}</span>
            </div>
            <div className='d-flex'>
              <h5 className='me-2'>Fecha de Inicio:</h5>
              <span>{checkIn.FechaInicio}</span>
            </div>
            <div className='d-flex'>
              <h5 className='me-2'>Fecha Fin:</h5>
              <span>{checkIn.FechaFin}</span>
            </div>
          </div>
        </div>
      </div>
    )
  }
)

const ModalCheckInDetail: FC<Props> = ({show, setShow, checkIn, getChekings}) => {
  const handleClose = () => {
    setShow(false)
  }

  const componentRef = useRef<any | null>(null)
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  })

  const handleSendMail = async (reservaCamaId: string) => {
    try {
      const data = await sendEmailCheckInOutService(reservaCamaId, 'IN')
      if (!data.data.error) {
        getSnackBar('Se envió el correo con éxito', true)
      } else {
        getSnackBar('Error interno, volver a intentarlo', false)
      }
    } catch (error) {}
  }

  const handleViewPdf = async (reservaCamaId: string) => {
    try {
      let dto = {
        reservaCamaId: reservaCamaId,
        tipo: 'IN',
        MotivoReimpresionId: '',
        Otros: '',
      }
      const response = await downloadPDFCheckInOutService(dto)
      const blob = new Blob([response.data], {
        type: 'application/pdf',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `CheckIn-${moment().format('DD/MM/YY HH:mm').toString()}.pdf` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      getChekings()
      getSnackBar('Se descargó el documento con éxito', true)
    } catch (error) {
      getSnackBar('Hubo un error al descargar', false)
    }
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Detalle CheckIn</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <div className='row mb-4'>
            <div className='d-flex'>
              <Button
                label='Enviar correo'
                classNameProp='me-3'
                onClick={() => handleSendMail(checkIn.ReservaCamaId)}
              />
              <Button
                label='Ver PDF'
                classNameProp='me-3'
                onClick={() => handleViewPdf(checkIn.ReservaCamaId)}
              />
              {/* <Button label='Imprimir' onClick={handlePrint} /> */}
            </div>
          </div>
          <hr className='divider' />
          <ComponentToPrint ref={componentRef} checkIn={checkIn} />
        </div>
      </div>
    </Modal>
  )
}

export {ModalCheckInDetail}
